<template>
    <main>
        <div class="main">
            <dl class="titleTip">
            <dt>专家简介</dt>
            <dd></dd>
       </dl>
        <div class="group">
            <div>
                <a :class="groupId === item.groupId ? 'select':''"
                    href="javascript: void 0;"
                    v-for="item in groupList"
                    :key="item.groupId"
                    @click.stop="changeGroup(item.groupId)">{{item.name}}</a>
            </div>
        </div>  
            <div class="mid">
                <ul>
                    <li v-for="item in experteList"
                        :key="item.expertId">
                        <img :src="item.img" />
                        <div>
                            <h1>{{item.expertName}}</h1>
                            <h2>{{item.position}}</h2>
                            <p>{{item.areas}}</p>
                            <a href="javascript: void 0;" @click.stop="toExperteDetails(item.expertId)">详情</a>
                        </div>
                    </li>                   
                </ul>
            </div>
            <!-- 分页器 -->
            <Pager :countNumber.sync="countNumber"
                   :currentPage.sync="currentPage"
                   :pagesizeList.sync="pagesizeList"
                   :pagesize.sync="pagesize"
                   :showPagesize="false"></Pager>
        </div>
    </main>
</template>
<script>
    import Pager from '../../../components/Pager/Pager';

    export default {
        name: 'ExperteList',
        components: {
            'Pager': Pager,
        },
        created() {
            this.getGroupList();
        },
        data() {
            return {
                groupList: [],
                experteList: [],
                groupId: '',
                // 分页器
                countNumber: 0,
                currentPage:1, // 当前页数
                pagesizeList: [9],
                pagesize: 9,
            }
        },
        methods: {
            changeGroup(id) {
                this.groupId = id;
                this.currentPage = 1;
            },
            getGroupList() {
                this.$api.getGroupList().then(r => {
                    if (r.code === 1) {
                        this.groupList = r.data;
                        this.groupId = r.data[0].groupId;
                    }
                })
            },
            getAllExpertListByLimit() {
                const params = {
                    groupId: this.groupId,
                    currentPage: this.currentPage,
                };
                this.$api.getAllExpertListByLimit(params).then(r => {
                    if (r.code === 1) {
                        this.countNumber = r.data.countNumber;
                        this.experteList = r.data.data;
                    } else {
                        console.error(r.message)
                    }
                });
            },
            toExperteDetails(id) {
                const path = '/expertelist/expertedetails?experteId='+id;
                let newpage = this.$router.resolve({ 
                    path: path, 
                });
                window.open(newpage.href, '_blank');
            },
        },
        watch: {
            groupId() {
                this.getAllExpertListByLimit();
            },
            currentPage() {
                this.getAllExpertListByLimit();
            },
        },
    }

</script>
<style lang="scss" scoped>
    @import './ExperteList.scss';
</style>